import React, { useState, useEffect } from 'react';
import './fleetblock.css';

const FleetBlock = () => {
  const [families, setFamilies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchFamilies();
  }, []);

  const fetchFamilies = async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/fleet_promo');
      const result = await response.json();

      if (result.success) {
        setFamilies(result.data);
      } else {
        setError('Не удалось загрузить данные о флоте');
      }
    } catch (err) {
      console.error('Ошибка загрузки:', err);
      setError('Ошибка соединения с сервером');
    } finally {
      setLoading(false);
    }
  };

  // Функция для получения иконки производителя
  const getManufacturerIcon = (manufacturer) => {
    switch (manufacturer) {
      case 'Airbus':
        return 'fa fa-airbus';
      case 'Boeing':
        return 'fa fa-boeing';
      case 'Embraer':
        return 'fa fa-plane';
      default:
        return 'fa fa-plane';
    }
  };

  // Группировка по производителям
  const groupedByManufacturer = {};
  families.forEach(family => {
    if (!groupedByManufacturer[family.manufacturer]) {
      groupedByManufacturer[family.manufacturer] = [];
    }
    groupedByManufacturer[family.manufacturer].push(family);
  });

  if (loading) {
    return (
      <div className="fleet-loading">
        <div className="spinner-small"></div>
        <p>Загрузка флота...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="fleet-error">
        <i className="fa fa-exclamation-circle"></i>
        <p>{error}</p>
        <button onClick={fetchFamilies} className="retry-small">
          <i className="fa fa-refresh"></i> Повторить
        </button>
      </div>
    );
  }

  return (
    <div className="content-section fleet-section">
      <h3 className="section-title">
        <span className="title-icon">🛩️</span>
        Наш флот
      </h3>
      <p>
        В нашем флоте имеются современные типы воздушных судов:
      </p>
      
      {Object.entries(groupedByManufacturer).map(([manufacturer, manufacturerFamilies]) => (
        <div key={manufacturer} className="manufacturer-group">
          <h4 className="manufacturer-title">
            <i className={getManufacturerIcon(manufacturer)}></i>
            {manufacturer}
          </h4>
          <div className="fleet-families">
            {manufacturerFamilies.map(family => (
              <a
                key={family.familyId}
                href={`/fleet/family/${family.familyId.toLowerCase()}`}
                className="family-link"
                title={`${family.displayName} (${family.count} модификаций)`}
              >
                <span className="family-button">
                  {family.displayName}
                </span>
              </a>
            ))}
          </div>
        </div>
      ))}
      
      <div className="fleet-footer">
        <a href="/fleet" className="view-all-link">
          Смотреть весь флот <i className="fa fa-arrow-right"></i>
        </a>
      </div>
    </div>
  );
};

export default FleetBlock;